import { render } from "./ImpersonatePerson.vue?vue&type=template&id=2fc35622&scoped=true"
import script from "./ImpersonatePerson.vue?vue&type=script&lang=js"
export * from "./ImpersonatePerson.vue?vue&type=script&lang=js"

import "./ImpersonatePerson.vue?vue&type=style&index=0&id=2fc35622&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fc35622"]])

export default __exports__